export const TasksActionTypes = {
    SET_TASK_DATA: 'SET_TASK_DATA',
    SET_TASKS_DATA:'SET_TASKS_DATA',
    SET_TASK_EDITING:'SET_TASK_EDITING',
    SET_SELECTED_TASK:'SET_SELECTED_TASK',
    REMOVE_SELECTED_TASK:'REMOVE_SELECTED_TASK'
  };